// Client for the Data Standards guide (/api/standards): overview, table pages and CSV / zip downloads (IT Head and COO).
import { headers, parse } from "./classificationApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/standards`;
const get = (p) => fetch(`${BASE}${p}`, { headers: headers(null, false) }).then(parse);

export const getStandards = () => get("");
export const getStandard = (t) => get(`/${t}`);
const pad = (n) => String(n).padStart(2, "0");
export const FILES = {
  template: (t, step) => [`/${t}/template.csv`, `${pad(step)}_${t}_template.csv`],
  example: (t, step) => [`/${t}/example.csv`, `${pad(step)}_${t}_example.csv`],
  dictionary: () => ["/dictionary.csv", "data_dictionary.csv"],
  all: () => ["/all.zip", "data_standards_templates.zip"],
};

export async function download([path, filename]) {
  const res = await fetch(`${BASE}${path}`, { headers: headers(null, false) });
  if (!res.ok) await parse(res);
  const url = URL.createObjectURL(await res.blob());
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const guideLink = (table, column) => `/admin/explorer?${new URLSearchParams({ view: "standards", table, ...(column ? { col: column } : {}) })}`;
